import React from "react";
import Typography from "@mui/material/Typography";
import useTranslation from "next-translate/useTranslation";

const Placeholder = ({ innerProps, children }) => {
  const { lang } = useTranslation();
  const direction = {
    ...(lang === "en" ? { left: 1.85 } : { right: 1.85 }),
  };
  return (
    <Typography
      sx={{ position: "absolute", color: "#8F8F8F", left: 1.85, ...direction }}
      className="!text-[12px] sm:!text-[16px] !font-Expo_bok !font-normal"
      {...innerProps}
    >
      {children}
    </Typography>
  );
};

export default Placeholder;
